import { authApi } from '@/api/auth'
import { getDeviceId, getDeviceName } from '@/utils/device'

const TOKEN_KEY = 'jlpt_token'
const USER_KEY = 'jlpt_user'
const REMEMBER_KEY = 'jlpt_remember_me'

function withDevice (dto) {
  return {
    ...dto,
    deviceId: getDeviceId(),
    deviceName: getDeviceName()
  }
}

export default {
  namespaced: true,

  state: () => ({
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  }),

  getters: {
    token: state => state.token,
    user: state => state.user,
    isLoggedIn: state => !!state.token && !!state.user,
    isAdmin: state => state.user && state.user.role === 'admin',
    // 是否有有效订阅（控制路由访问）
    hasActiveSubscription: state =>
      state.user && state.user.subscriptionStatus === 'active',
    subscriptionStatus: state =>
      state.user ? state.user.subscriptionStatus : 'none',
    subscriptionExpiry: state =>
      state.user ? state.user.subscriptionExpiry : null
  },

  mutations: {
    SET_AUTH (state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    UPDATE_USER (state, user) {
      state.user = user
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    CLEAR_AUTH (state) {
      state.token = ''
      state.user = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
    }
  },

  actions: {
    async login ({ commit }, loginDto) {
      const res = await authApi.login(withDevice(loginDto))
      localStorage.setItem(REMEMBER_KEY, loginDto.rememberMe ? '1' : '0')
      commit('SET_AUTH', { token: res.data.accessToken, user: res.data.user })
      return res.data
    },

    async register ({ commit }, registerDto) {
      const res = await authApi.register(withDevice(registerDto))
      commit('SET_AUTH', { token: res.data.accessToken, user: res.data.user })
      return res.data
    },

    // 支付成功后调用，刷新 Token 中的订阅状态
    async refreshSubscription ({ commit }) {
      const rememberMe = localStorage.getItem(REMEMBER_KEY) === '1'
      const res = await authApi.refreshSubscription(rememberMe)
      commit('SET_AUTH', { token: res.data.accessToken, user: res.data.user })
      return res.data
    },

    async logout ({ commit }) {
      try {
        await authApi.unregisterDevice({
          deviceId: getDeviceId(),
          deviceName: getDeviceName()
        })
      } catch { /* 忽略 */ }
      commit('CLEAR_AUTH')
    }
  }
}
